import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import Title from '../Title/Title';

import PortfolioContext from '../../context/context';
import graphic from '../../images/graphic.webp';

const About = () => {
  const { about } = useContext(PortfolioContext);
  const { paragraphOne, paragraphTwo, resume } = about;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="about">
      <Container>
        <Title title="About Me" />
        <Row className="about-wrapper">
          <Col md={6} sm={12}>
            <Fade bottom duration={1000} delay={600} distance="30px">
              <div className="about-wrapper__image">
                <img className="about-img" src={graphic} alt="Logo" />
              </div>
            </Fade>
          </Col>
          <Col md={6} sm={12} pl={10}>
            <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
              <div className="about-wrapper__info">
                <p className="about-wrapper__info-text">
                  {paragraphOne ||
                    'Hello! My name is Johns and I am a front-end web developer with over 3 years of experience. My interest in web development started in 2019 when I landed my first internship during university at a startup company that created a marketplace to buy and sell university textbooks. I’ve worked as a freelancer and at many startups across the globe to create high performance & rich interactive websites that work across all platforms & devices.'}
                </p>
                <p className="about-wrapper__info-text">
                  {paragraphTwo ||
                    'When not working, you will find me studying full time towards an Electrical & Computer Engineering degree from the University of Cape Town.'}
                </p>

                {resume && (
                  <span className="d-flex mt-3">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-btn cta-btn--resume"
                      href={resume}
                    >
                      View CV
                    </a>
                  </span>
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
